import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ModuleWithProviders, APP_INITIALIZER, Provider } from '@angular/core';

import { organizationInitializerFactory } from './factories';
import { HasOrganizationPrefix } from './guards';
import { getOrganizationPrefix } from './helpers';
import { FsDetachNoAuthInterceptor } from './interceptors/fs-detach-no-auth.interceptor';
import { ORGANIZATION_PREFIX } from './providers';
import { PublicOrganization } from './services';

const PREFIX = getOrganizationPrefix();

const PROVIDERS: Provider[] = [HasOrganizationPrefix];

if (PREFIX) {
  PROVIDERS.push(
    {
      provide: ORGANIZATION_PREFIX,
      useValue: PREFIX,
    },
    {
      provide: PublicOrganization,
      useClass: PublicOrganization,
      deps: [ORGANIZATION_PREFIX],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: organizationInitializerFactory,
      deps: [ORGANIZATION_PREFIX, PublicOrganization, HttpClient],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FsDetachNoAuthInterceptor,
      multi: true,
    },
  );
}

@NgModule({
  imports: [CommonModule],
})
export class AuthPublicModule {
  public static forRoot(): ModuleWithProviders<AuthPublicModule> {
    return {
      ngModule: AuthPublicModule,
      providers: PROVIDERS,
    };
  }
}
